import { render, staticRenderFns } from "./PopupForTutorial.vue?vue&type=template&id=1e865b4c&scoped=true&"
import script from "./PopupForTutorial.vue?vue&type=script&lang=js&"
export * from "./PopupForTutorial.vue?vue&type=script&lang=js&"
import style0 from "./PopupForTutorial.vue?vue&type=style&index=0&id=1e865b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e865b4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
